// extracted by mini-css-extract-plugin
export var adjacentSlide = "_p0-9";
export var arrowButtonContainer = "_p0-5";
export var arrowButtonIcon = "_p0-6";
export var carouselArrowButton = "_p0-2";
export var carouselElementContainer = "_p0-1";
export var currentSlide = "_p0-8";
export var left = "_p0-3";
export var otherSlide = "_p0-a";
export var productCarouselContainer = "_p0-0";
export var right = "_p0-4";
export var sliderOverflow = "_p0-7";